export const DTC_INCENTIVE = '$20';
export const B2B_INCENTIVE = '$50';
